/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Section_Scene_DescriptionInputs */



/**
* | output |
* | --- |
* | "Scene Description Settings" |
*
* @param {Ad_Section_Scene_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_section_scene_description = /** @type {((inputs?: Ad_Section_Scene_DescriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Section_Scene_DescriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Paramètres de description des scènes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Einstellungen für Szenenbeschreibungen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impostazioni descrizione scene")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Настройки описания сцен")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ajustes de descripción de escenas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("场景描述设置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("シーン説明の設定")
	if (locale === "hi") return /** @type {LocalizedString} */ ("दृश्य विवरण सेटिंग्स")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Definições de descrição de cenas")
	return /** @type {LocalizedString} */ ("Scene Description Settings")
});